/*global Modernizr */
/*jslint browser:true */

(function() {
  'use strict';

  var la_name_form = document.getElementById('tec-lobby-activity-search-name'),
      la_expenditure_form = document.getElementById('tec-lobby-activity-search-expenditure');

  if(la_name_form) {
    var field_name_type = la_name_form.querySelector('#form-name-search-type'),
        field_name_year = la_name_form.querySelector('#field-name-year'),
        field_name_lobby_name = la_name_form.querySelector('#field-name-lobby-name'),
        field_name_lobbyist_id = la_name_form.querySelector('#field-name-lobbyist-id');

    field_name_type.addEventListener('change', (e) => {
      // Fallback for browsers that don't support View Transitions:
      if (!document.startViewTransition) {
        check_la_name_form();
      } else {
        document.startViewTransition(() => check_la_name_form());
      }
    });

    setTimeout(function() {
      check_la_name_form();
    }, 100);
  }

  if(la_expenditure_form) {
    var field_expenditure_type = la_expenditure_form.querySelector('#form-expenditure-search-type'),
        field_expenditure_year = la_expenditure_form.querySelector('#field-expenditure-year'),
        field_expenditure_expend_type = la_expenditure_form.querySelector('#field-expenditure-expend-type'),
        field_expenditure_persons_type = la_expenditure_form.querySelector('#field-expenditure-persons-type'),
        field_expenditure_amount_range = la_expenditure_form.querySelector('#field-expenditure-amount-range');

    field_expenditure_type.addEventListener('change', (e) => {
      // Fallback for browsers that don't support View Transitions:
      if (!document.startViewTransition) {
        check_la_expenditure_form();
      } else {
        document.startViewTransition(() => check_la_expenditure_form());
      }
    });

    setTimeout(function() {
      check_la_expenditure_form();
    }, 100);
  }

  function check_la_name_form() {
    if(field_name_type.value === 'lobbyist_name') {
      tec_search_form_field_show(field_name_year);
      tec_search_form_field_show(field_name_lobby_name);
      tec_search_form_field_hide(field_name_lobbyist_id);
    } else if(field_name_type.value === 'lobbyist_id') {
      tec_search_form_field_show(field_name_year);
      tec_search_form_field_hide(field_name_lobby_name);
      tec_search_form_field_show(field_name_lobbyist_id);
    } else {
      tec_search_form_field_hide(field_name_year);
      tec_search_form_field_hide(field_name_lobby_name);
      tec_search_form_field_hide(field_name_lobbyist_id);
    }
  }

  function check_la_expenditure_form() {
    if(field_expenditure_type.value === 'expenditure') {
      tec_search_form_field_show(field_expenditure_year);
      tec_search_form_field_show(field_expenditure_expend_type);
      tec_search_form_field_hide(field_expenditure_persons_type);
      tec_search_form_field_show(field_expenditure_amount_range);
    } else if(field_expenditure_type.value === 'persons') {
      tec_search_form_field_show(field_expenditure_year);
      tec_search_form_field_hide(field_expenditure_expend_type);
      tec_search_form_field_show(field_expenditure_persons_type);
      tec_search_form_field_show(field_expenditure_amount_range);
    } else {
      tec_search_form_field_hide(field_expenditure_year);
      tec_search_form_field_hide(field_expenditure_expend_type);
      tec_search_form_field_hide(field_expenditure_persons_type);
      tec_search_form_field_hide(field_expenditure_amount_range);
    }
  }
}());
